<template>
    <div>
        <a target="_blank" href="https://beian.miit.gov.cn/" rel="noopener noreferrer">
            <p>京ICP备15010781号-2</p>
        </a>
    </div>
</template>

<script>
export default {
    name: 'HomeIndex',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
    justify-content: end;
    flex-direction: column;
    display: flex;
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 100vh;
    background-image: url('../assets/home_bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

a {
    color: #000000;
    text-decoration: none;
}

p {
    color: #000000;
    text-align: center;
    width: 100%;
    font-size: 15px;
}
</style>
